import './App.css';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Login from './Components/Login';
import Navbar from './Components/Navbar';
import Sidebar from './Components/Sidebar';
import EditProfilePage from './Components/EditProfilePage';
import AddUser from './Components/AddUser';
import AlreadyWhitelistkeyandip from './Components/AlreadyWhitelistkeyandip';
import APIKeyGenerate from './Components/APIKeyGenerate';
import Newipwhitelist from './Components/Newipwhitelist';
import APIKeywiseSummaryreport from './Components/APIKeywiseSummaryreport';
import ErrorwiseSummaryReport from './Components/ErrorwiseSummaryReport';
import Detailedreport from './Components/Detailedreport';
import DownloadCenter from './Components/DownloadCenter';
import SenderWhitslist from './Components/SenderWhitelist';
import TemplateWhitelist from './Components/TemplateWhitelist';
import Dashboard from './Components/Dashboard';
import DatewiseSummaryReport from './Components/DatewiseSummaryReport';
import UserSummaryReport from './Components/UserSummaryReport';
import SenderSummaryReport from './Components/SenderSummaryReport';
import CreditManagement from './Components/CreditManagement';
import ViewWhitelistedSender from './Components/ViewWhitelistedSender';
import ViewWhitelistedTemplate from './Components/ViewWhitelistedTemplate';
import UserManagement from './Components/UserManagement';
function App() {
  const navigate = useNavigate();
  const [showSidebar, setShowSidebar] = useState(window.innerWidth > 800); // Default value based on screen width
  const location = useLocation();
  // Function to check if Navbar and Sidebar should be rendered
  const shouldRenderNavbarAndSidebar = () => {
    return location.pathname !== '/login';
  };

  const loginData = JSON.parse(sessionStorage.getItem("loginData"));
  console.log("LoginData:" + loginData);
  
  useEffect(() => {
    if (loginData === null) {
      navigate('/login');
    }
  }, [navigate]);

  // Function to toggle sidebar visibility
  const toggleSidebar = () => {
    setShowSidebar(!showSidebar);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 800) {
        setShowSidebar(true); // Always show sidebar for larger screens
      } else {
        setShowSidebar(false); // Hide sidebar for smaller screens
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="App-container">
      <div className='outermost-container'>
        {shouldRenderNavbarAndSidebar() && <Navbar toggleSidebar={toggleSidebar} />}
        <div className={shouldRenderNavbarAndSidebar() ? 'main-content-div' : 'main-content-without-div'}>
          {shouldRenderNavbarAndSidebar() && showSidebar && <Sidebar />}
          <div className={shouldRenderNavbarAndSidebar() ? 'maincontentwithsidebar' : 'maincontentwithoutsidebar'}>
          <Routes>
          <Route path='/login' element={<Login />} />
          <Route path='/' element={<Dashboard />} />
          <Route path='/editprofile' element={<EditProfilePage />} />
          <Route path='/adduser' element={<UserManagement />} /> 
          <Route path='/whitelistedkeyandip' element={<AlreadyWhitelistkeyandip />} />
          <Route path='/apikeygenerate' element={<APIKeyGenerate />} />
          <Route path='/newipwhitelist' element={<Newipwhitelist />} />
          <Route path='/datewisesummary' element={<DatewiseSummaryReport />} />
          <Route path='/usersummary' element={<UserSummaryReport />} />
          <Route path='/sendersummary' element={<SenderSummaryReport />} />
          <Route path='/apikeysummary' element={<APIKeywiseSummaryreport />} />
          <Route path="/errorcodewisesummary" element={<ErrorwiseSummaryReport />} />
          <Route path='/detailedreport' element={<Detailedreport />} />
          <Route path='/downloadcenter' element={<DownloadCenter />} />
          <Route path='/senderwhitelist' element={<SenderWhitslist />} />
          <Route path='/templatewhitelist' element={<TemplateWhitelist />} />
          <Route path='/creditmanagement' element={<CreditManagement />} />
          <Route path='/viewsenderwhitelisted' element={<ViewWhitelistedSender />} />
          <Route path='/viewtemplatewhitelisted' element={<ViewWhitelistedTemplate />} />
        </Routes>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
